import type { CustomizeRequest, CustomizeResponse } from '~/contracts/new-cars';

export default function detectTrimLevelSelections(
  data: CustomizeResponse
): Partial<CustomizeRequest> {
  const result: Partial<CustomizeRequest> = {};

  const availableDriveTypes = data.driveTypes.filter(d => d.count > 0);
  if (availableDriveTypes.length === 1) {
    result.driveType = availableDriveTypes[0].name;
  }

  const availableEngines = (data.engines ?? []).filter(e => e.count > 0);
  if (availableEngines.length === 1) {
    result.engineCode = availableEngines[0].code;
  }

  const availableExteriors = data.exteriorColors.filter(c => c.count > 0);
  if (availableExteriors.length === 1) {
    result.exteriorColorCode = availableExteriors[0].code;
  }

  const availableInteriors = data.interiorColors.filter(c => c.count > 0);
  if (availableInteriors.length === 1) {
    result.interiorColorCode = availableInteriors[0].code;
  }

  const availablePackages = data.packageOptions.filter(p => p.count > 0);
  if (availablePackages.length === 1 && availablePackages[0].code === 'NONE') {
    result.packageOptionCodes = ['NONE'];
  }

  return result;
}
